<h1 class="title">Chart Of Accounts</h1>
<h5>&nbsp;</h5>
<div class="cas-wrapper">
    <ng-container *ngIf="!isLoading else loadingView">
        <p-tabView orientation="right" (onChange)="selectTab($event)" [activeIndex]="index">
            <ng-container *ngFor="let tab of tabs; let i= index">
                <p-tabPanel [header]="tab.name" ng-reflect-style-class="cas-tab-height">
                    <acabim-admin-financial-datatable
                        [currentIndex]="i"
                        [classId]="tab.id"
                        [classes]="tabs"></acabim-admin-financial-datatable>
                </p-tabPanel>
            </ng-container>
        </p-tabView>
    </ng-container>
</div>
<ng-template #loadingView>
    <acabim-loading-view></acabim-loading-view>
</ng-template>

